import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const {
      page = 1,
      limit = 20,
      status,
      userRole,
    } = payload || {}

    return buildApiUrl(ADMIN_ENDPOINTS.CLIENT_DEBTS, {
      queryParams: {
        page: 1,
        limit: 2000,
        status,
        userRole,
      }
    })
  },

  parse(raw = {}) {
    if (!raw.success) {
      return { result: [], total: 0, page: 1, limit: 20 }
    }
    let formatted = (raw.data || []).map(d => ({
        id: d.id,
        userId: d.userId,
        userRole: d.userRole,
        purchaseId: d.purchaseId,
        productId: d.productId,
        productName: d.productName,
        originalAmount: d.originalAmount || 0,
        remainingAmount: d.remainingAmount || 0,
        paidAmount: d.paidAmount || 0,
        status: d.status,
        history: d.history || [],
        createdAt: d.createdAt,
        updatedAt: d.updatedAt,
      }))

    let finalData = formatted
    // === Recherche textuelle locale ===
    const searchTerm = (payload?.search || '').toString().trim().toLowerCase()
    if (searchTerm) {
      finalData = finalData.filter(el => {
        return Object.values(el).some(val => 
          val && typeof val !== 'object' && String(val).toLowerCase().includes(searchTerm)
        )
      })
    }

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      finalData = [...finalData].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') return valA.localeCompare(valB) * order
        if (typeof valA === 'number' && typeof valB === 'number') return (valA - valB) * order
        return 0
      })
    }

    // === Pagination locale ===
    const { page = 0, limit = 20 } = payload || {}
    const paginated = finalData.slice(page * limit, (page + 1) * limit)

    return {
      result: paginated,
      total: searchTerm ? finalData.length : (raw.pagination?.total || formatted.length),
      page: raw.pagination?.page || 1,
      limit: raw.pagination?.limit || 20,
    }
  },

  filters: {
    page: 0,
    limit: 20,
    status: undefined,
    userRole: undefined,
  },
}
